import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TaskstatusDashboard from '../TaskstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function TaskstatusPage() {
    const dispatch = useDispatch();
    const { TaskstatusList} = useSelector((state)=>state.manufaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < TaskstatusDashboard />
    )

}